import React from 'react';
import ActivityScoreHelp from './ActivityScoreHelp';

const Help = () => (
  <>
    <ActivityScoreHelp />
  </>
);

export default Help;
